import { CalendarDays } from "lucide-react";
import { reportingDaysAgo } from "../utils/reporting-date";

export type DateRangePickerProps = {
  from: string;
  to: string;
  onChange: (range: { from: string; to: string }) => void;
};

export function DateRangePicker({ from, to, onChange }: DateRangePickerProps) {
  return (
    <div className="control-group">
      <CalendarDays size={16} aria-hidden="true" />
      <button type="button" onClick={() => onChange({ from: reportingDaysAgo(0), to: reportingDaysAgo(0) })}>
        今天
      </button>
      <button type="button" onClick={() => onChange({ from: reportingDaysAgo(1), to: reportingDaysAgo(1) })}>
        昨天
      </button>
      <button type="button" onClick={() => onChange({ from: reportingDaysAgo(6), to: reportingDaysAgo(0) })}>
        近 7 天
      </button>
      <button type="button" onClick={() => onChange({ from: reportingDaysAgo(29), to: reportingDaysAgo(0) })}>
        近 30 天
      </button>
      <input aria-label="開始日期" type="date" value={from} onChange={(event) => onChange({ from: event.target.value, to })} />
      <input aria-label="結束日期" type="date" value={to} onChange={(event) => onChange({ from, to: event.target.value })} />
    </div>
  );
}
